import { IIconProps } from './type'

export const UpChevron: React.FC<IIconProps> = ({ height = '24', width = '24', color = '#808080' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 14L12 10L8 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
